<section translate="no">
    <section style="height: auto;">
        <nav>
            <ol class="cd-breadcrumb custom-separator">
                <table>
                    <tbody>
                        <tr>
                            <td class="nomeTela">
                                Cadastro de Perfil de usuários
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ol>
        </nav>
    </section>
    <main>
        @if(perfilEditado == true){
        <div class="alert alert-success" role="alert">
            Usuário editado com sucesso !
        </div>
        }@if(perfilEditado == false){
        <div class="alert alert-danger" role="alert">
            Ocorreu algum problema na edicação !
        </div>
        }
        @if(perfilSalvo == true){
        <div class="alert alert-success" role="alert">
            Usuário cadastrado com sucesso !
        </div>
        }@if(perfilSalvo == false){
        <div class="alert alert-danger" role="alert">
            Ocorreu algum problema no cadastro !
        </div>
        }

        <!--Tabela -->
        @if(validarRole() == true ){
        <div class="btnplus" [ngClass]="{'subeButtonAdd': subeButtonAdd}"
            style="position: fixed; bottom: 13px;right: 22px;">
            <a [routerLink]="['/create-users']"><button id="class-button"
                    style="border-radius: 50%;width: 45px;height: 45px;" class="btn btn-success"><i
                        class="fas fa-plus"></i></button></a>
        </div>
        }


        <section class="pesq-section">
            <form class="form-class" data-toggle="collapse" (ngSubmit)="MudaFiltro()">
                <div class="div_busca_orientacao">
                    <div class="item_pesquisa">
                        <div class="form-div p-3">
                            <label for="pesquisaNome" class="form-label">Nome Usuário:</label>
                            <input type="text" class="form-control" placeholder="Descrição" id="pesquisaNome"
                                name="pesquisaNome" [(ngModel)]="pesquisaNome" required style="text-transform: uppercase;">
                        </div>
                    </div>
                    <div class="item_pesquisa">
                        <div class="form-div p-3">
                            <label for="pesquisaCPF" class="form-label">CPF:</label>
                            <input type="text" mask="000.000.000-00" maxlength="14" [dropSpecialCharacters]="false"
                                class="form-control" placeholder="CPF" id="pesquisaCPF" name="pesquisaCPF"
                                [(ngModel)]="pesquisaCPF">
                        </div>
                    </div>
                    <div class="item_pesquisa">
                        <div class="form-div p-3">
                            <label for="mySelectFiltroPerfil" class="form-label">Perfil:</label>
                            <select #mySelectFiltroPerfil name="select" aria-placeholder="Perfil" class="form-select"
                                (change)="onOptionChangeFiltroPerfil(mySelectFiltroPerfil.value)">
                                <option value=""></option>
                                <option *ngFor="let objeto of listaPerfil" value={{objeto.perfil}}>{{objeto.desc}}
                                </option>
                                <option value="-1">Sem Perfil</option>
                            </select>
                        </div>
                    </div>

                    <div class="item_pesquisa">
                        <div class="form-div p-3">
                            <label for="posto" class="form-label">Posto:</label>
                            <app-multiple-selection-select-all [lista]="listaPostos" [width]="larguraTela/2.5"
                                [multiplePosto]="false" [regiaoSelecionada]="regiaoSelecionada" [SemOpTodos]="true"
                                (infoClicada)="processarInfo($event)"></app-multiple-selection-select-all>
                        </div>
                    </div>

                    <div>
                        <div class="div-button mb-3 p-3" style="margin-top: 47px;">
                            <button id="class-button" type="submit"
                                class="btn btn-primary btnpesquisa">Pesquisar</button>
                        </div>
                    </div>
                </div>
            </form>
        </section>
        <section class="main-section-table">
            <div class="tabela-wrapper">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Nome do usuário</th>
                            <th scope="col">CPF</th>
                            <th scope="col">Perfil</th>
                            <th scope="col">Edição</th>
                        </tr>
                    </thead>
                    <tbody>
                        @if (userPerfilControlLista && userPerfilControlLista.length ) {
                        <tr *ngFor="let users of userPerfilControlLista ">
                            <td>{{ users.nome }}</td>
                            <td>{{ users.cpf }}</td>
                            <td>{{ users.meusDados?.roles?.SALADESITUACAO?.perfil }}</td>
                            <td> <button class="btn btn-primary" [routerLink]="['/editar-users']"
                                    [queryParams]="{id: users.id}">Editar Perfil </button>
                                @if(validarRole() == true){
                                <a [routerLink]="['/auditoria-listagem']"
                                    [queryParams]="{id: users.cpf, tabela: 'Usuario'}"><button class="btn btn-secondary"
                                        style="margin-left: 10px;"><i class="fas fa-history"></i></button></a>
                                }
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            <br>
            <mat-paginator #paginator class="demo-paginator" (page)="handlePageEvent($event)" [length]="totalPages"
                [pageSize]="pageSize" [disabled]="disabled" [showFirstLastButtons]="showFirstLastButtons"
                [pageSizeOptions]="[5, 10, 25, 100]" [hidePageSize]="true" [pageIndex]="pageIndex"
                aria-label="Select page"> </mat-paginator>
        </section>
    </main>
    <div style="height: 150px;">
    </div>
</section>
